import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { QuoteSection } from "@/components/QuoteSection";
import { Gallery } from "@/components/Gallery";
import { Storefront } from "@/components/Storefront";
import { Testimonials } from "@/components/Testimonials";
import { LocationSection } from "@/components/Location";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-ivory text-foreground font-sans antialiased overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <QuoteSection />
        <Gallery />
        <Storefront />
        <Testimonials />
        <LocationSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
